// Regex that matches all words which are properly defined variable names
// (Case in-sensitive, alphanumeric, optionally split by "_", or ".")
const IS_VARIABLE_REGEX = /^\$[a-zA-Z]+[a-zA-Z0-9]*(?:[_.][a-zA-Z0-9]+)*$/g;

/**
 * Regex that matches all characters that need to be escaped, but are not.
 * https://regex101.com/r/gPeWnE
 * @internal
 */
export const NEEDS_ESCAPING_REGEX = /(?<!\\)(?:\\\\)*[ *,()!<>="$:[\]~]|(\\$)/g;

/**
 * Regex that matches all escaped characters, including the escape character and escaped character.
 * https://regex101.com/r/LNo0qJ/1
 * @internal
 */
export const ESCAPED_CHARACTERS_REGEX = /\\(?:.)/g;

/** @internal */
export function escapeSuggestion(value: string): string {
  // A standalone asterisk (position operator) and exists operators are the
  // only suggestions that should not be escaped automatically.
  if (value === '*' || value === '= *' || value === '!= *') {
    return value;
  }

  // Properly defined variables should not get escaped
  if (value.startsWith('$') && new RegExp(IS_VARIABLE_REGEX).exec(value)) {
    return value;
  }

  const isSuggestionEscaped = new RegExp(/^"[^"]*"$/).exec(value);

  if (isSuggestionEscaped) {
    return value;
  }

  const matches = new RegExp(NEEDS_ESCAPING_REGEX).exec(value);

  // If the regex matches, there is at least one character in the applied suggestion
  // that needs to be escaped, but is not. In this case, we remove all the backslashes
  // that do not escape a backslash and wrap the whole suggestion in doublequotes.
  // Doublequotes ocurring in the applied value are still escaped with a backslash to not
  // close the string.
  // It would not be necessary to wrap 'te\"st' in doublequotes, since the included
  // doublequote is already escaped by a backslash. To not overcomplicate the logic,
  // we still wrap the whole value.
  if (matches) {
    return `"${value
      .replaceAll(/(?<!\\)(?:\\\\)*(\\)(?!\\)/g, '')
      .replaceAll('"', '\\"')}"`;
  }

  return value;
}
